export const SideMenu: Array<any> = [
    {
        title: 'Stammdaten',
        version: 'default',
        items: [
            {
                title: 'Meine Hautschutz-Ziele',
                url: '/user-goals',
                icon: '',
                // icon source must be path from app.component.ts
                iconSrc: '../assets/custom-ion-icons/target-icon.svg'
            },
        ],
    },
    {
        title: 'Dokumentation',
        version: 'default',
        items: [
            {
                title: 'Mein Hautschutz-Verhalten',
                url: '/',
                icon: 'bar-chart',
                root: true
            },
            {
                title: 'Meine Hautdokumentation',
                url: '/weekly-skin-entry',
                icon: 'camera',
                root: true
            },
        ]
    },
    {
        title: 'Auswertung',
        version: 'default',
        items: [
            {
                title: 'Hautschutz-Ziele bewerten',
                url: '/user-goals/survey',
                icon: 'checkmark-circle'
            },
            {
                title: 'Meine Zielerreichung',
                url: '/user-goals/survey/overview',
                icon: 'golf'
            },

        ]
    },
    {
        title: 'Hilfe und Weiteres',
        version: 'default',
        items: [
            {
                title: 'Hörenswert',
                url: '/podcasts',
                icon: 'ear'
            },
            {
                title: 'Das Hautschutz 1x1',
                url: '/skincare-questions',
                icon: 'book'
            },
            {
                title: 'Meine Zuständigkeiten',
                url: '/faq',
                icon: 'help'
            },
        ]
    }
];
